function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getChannelLogo } from "@common/utils/helpers";
import { DISABLE_CHANNEL_REORDER, ROUTE_ON_RECORD_INITIAL_PAGE_SIZE } from "@config/constants";
import { isString } from "lodash";
import React, { PureComponent } from "react";
import { Draggable } from "react-beautiful-dnd";
import LazyLoad from "react-lazy-load";
import { connect } from "react-redux";
var getLogoUrl = function(channelLogo, isCentered, isOpened, isSmallMobile) {
    var logo = "";
    if (channelLogo) {
        if (isOpened && isSmallMobile) {
            logo = channelLogo.pngWhite;
        } else {
            logo = isCentered ? channelLogo.svgCentered : channelLogo.svgLeft;
        }
    }
    return logo;
};
var ChannelListItem = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ChannelListItem, PureComponent);
    var _super = _create_super(ChannelListItem);
    function ChannelListItem(props) {
        _class_call_check(this, ChannelListItem);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "getLogo", function() {
            var _ref = _async_to_generator(function(url, isCentered) {
                var default_channel_logo_svg, result, svgLogo, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            default_channel_logo_svg = DEFAULT_CHANNEL_LOGO[isCentered ? "center" : "left"];
                            result = {
                                svg: null,
                                imageURL: null
                            };
                            // handles the logo if it's in png format
                            if (isString(url) && url.includes(".png") && window.innerWidth <= CHANNEL_MOBILE_PX) {
                                result.imageURL = url;
                            }
                            if (!url || isString(url) && !url.includes(".svg")) {
                                result.svg = default_channel_logo_svg;
                            }
                            if (!(!result.svg && !result.imageURL)) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                getChannelLogo(url, isCentered)
                            ];
                        case 2:
                            svgLogo = _state.sent();
                            result.svg = svgLogo;
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2,
                                result
                            ];
                    }
                });
            });
            return function(url, isCentered) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property(_assert_this_initialized(_this), "onImageError", function(event) {
            var currentTarget = event.currentTarget;
            currentTarget.onerror = null;
            currentTarget.src = "data:image/svg+xml;base64,".concat(btoa(DEFAULT_CHANNEL_LOGO["center"]));
        });
        _define_property(_assert_this_initialized(_this), "renderChannelLogo", function(id, index) {
            var _this_state;
            var logo = (_this_state = _this.state) === null || _this_state === void 0 ? void 0 : _this_state.logo;
            var _ref = logo || {}, svg = _ref.svg, imageURL = _ref.imageURL;
            var content = null;
            if (svg) {
                content = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: svg
                    }
                });
            }
            if (imageURL) {
                content = /*#__PURE__*/ _jsx("img", {
                    src: imageURL,
                    alt: "channel logo",
                    onError: _this.onImageError
                });
            }
            var logoTemplate = /*#__PURE__*/ _jsx("div", {
                className: "settings-list__item__logo svg-logo",
                children: content
            });
            return index > ROUTE_ON_RECORD_INITIAL_PAGE_SIZE ? /*#__PURE__*/ _jsx(LazyLoad, {
                offset: 1000,
                debounce: false,
                children: logoTemplate
            }) : logoTemplate;
        });
        _this.state = {
            logo: {}
        };
        return _this;
    }
    _create_class(ChannelListItem, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var _logoObj_, logosList, logoObj, url, logo;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                logosList = Object.entries(_this.props.logos);
                                logoObj = logosList.find(function(logo) {
                                    return logo[0] === _this.props.channel.id;
                                });
                                url = "/assets/media/maintenance-logo.png";
                                if (logoObj === null || logoObj === void 0 ? void 0 : (_logoObj_ = logoObj[1]) === null || _logoObj_ === void 0 ? void 0 : _logoObj_.svgCentered) {
                                    url = logoObj[1].svgCentered;
                                }
                                return [
                                    4,
                                    _this.getLogo(url)
                                ];
                            case 1:
                                logo = _state.sent();
                                _this.setState({
                                    logo: logo
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            // renderChannelLogo = (channel, index) => {
            //     const logoTemplate = (
            //         <span className="settings-list__item__logo svg-logo" key={`channel-list-item-${index}`}>
            //             <img className="img-fluid" src={this.getLogo(channel.id)} onError={this.onImageError} alt="channel logo"/>
            //         </span>
            //     )
            //     return index > ROUTE_ON_RECORD_INITIAL_PAGE_SIZE ?
            //         <LazyLoad offset={1000} debounce={false}>{ logoTemplate }</LazyLoad> :
            //         logoTemplate
            // }
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, isDraggable = _this_props.isDraggable, index = _this_props.index, visible = _this_props.visible, locked = _this_props.locked, channel = _this_props.channel, onHideToggle = _this_props.onHideToggle, onLockToggle = _this_props.onLockToggle;
                return /*#__PURE__*/ _jsx(Draggable, {
                    isDragDisabled: !isDraggable || DISABLE_CHANNEL_REORDER,
                    draggableId: channel.id,
                    index: index,
                    children: function(provided, snapshot) {
                        return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                            ref: provided.innerRef
                        }, provided.draggableProps, provided.dragHandleProps), {
                            style: _object_spread_props(_object_spread({}, provided.draggableProps.style), {
                                boxShadow: snapshot.isDragging ? "0 0 .4rem #666" : "none",
                                marginBottom: "8px",
                                display: channel.access === 0 ? "none" : "block"
                            }),
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "settings-list__item channels-table-wrap",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "channels-table__item channels-table__item-control",
                                        onClick: onHideToggle,
                                        onKeyDown: onHideToggle,
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "channels-table__item-icon ".concat(visible ? "icon-settings-font-view-show" : "icon-settings-font-hide-show")
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "channels-table__item channels-table__item-control",
                                        onClick: onLockToggle,
                                        onKeyDown: onLockToggle,
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "channels-table__item-icon ".concat(locked ? "icon-settings-font-lock" : "icon-settings-font-unlock disable-icon")
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "channels-table__item",
                                        children: _this.renderChannelLogo(channel.id, index)
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "channels-table__item",
                                        children: /*#__PURE__*/ _jsx("p", {
                                            className: "settings-list__item-text",
                                            children: channel.name
                                        })
                                    }),
                                    isDraggable && !DISABLE_CHANNEL_REORDER && /*#__PURE__*/ _jsx("div", {
                                        className: "channels-table__item channels-table__item__last-child channels-table__item__drag",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "channels-table__item-icon icon-settings-font-drag"
                                        })
                                    })
                                ]
                            })
                        }));
                    }
                });
            }
        }
    ]);
    return ChannelListItem;
}(PureComponent);
var mapStateToProps = function(param) {
    var logos = param.logos;
    return {
        logos: logos
    };
};
export default connect(mapStateToProps)(ChannelListItem);
